import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AuditionDetailHero.module.css';
import Icon from '../../components/common/Icon/Icon';

const CATEGORY_STYLES = {
  '드라마':   { color: '#E07B1B', borderColor: '#E07B1B' },
  '웹드라마': { color: '#E07B1B', borderColor: '#E07B1B' },
  '영화':     { color: '#2563EB', borderColor: '#2563EB' },
  '광고':     { color: '#7C3AED', borderColor: '#7C3AED' },
  '뮤지컬':  { color: '#059669', borderColor: '#059669' },
};

const GRADIENT_CATEGORIES = new Set(['TV(OTT)', 'OTT', '드라마(OTT)']);

function CategoryBadge({ category }) {
  if (GRADIENT_CATEGORIES.has(category)) {
    return (
      <span className={styles.categoryBadge} style={{ border: 'none', padding: '3px 8px' }}>
        <span style={{
          background: 'linear-gradient(90deg, #FFD92B, #FFB517)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          {category}
        </span>
      </span>
    );
  }
  const style = CATEGORY_STYLES[category] ?? { color: '#888896', borderColor: '#e9e9ec' };
  return <span className={styles.categoryBadge} style={style}>{category}</span>;
}

function AuditionDetailHero({ category, isNew, status, isClosing, title, companyId, companyName, castingDirectorName, isVerified }) {
  const navigate = useNavigate();
  return (
    <div className={styles.hero}>
      <div className={styles.badges}>
        {(isClosing || status === 'closing') && (
          <span className={styles.closingBadge}>마감임박</span>
        )}
        {isNew && <span className={styles.newBadge}>NEW</span>}
        <CategoryBadge category={category} />
      </div>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.company}>
        <span
          className={styles.companyName}
          onClick={() => companyId && navigate(`/companies/${companyId}`)}
          style={companyId ? { cursor: 'pointer', textDecoration: 'underline' } : undefined}
        >
          {companyName}
        </span>
        {castingDirectorName && (
          <span className={styles.companyName} style={{ color: '#888896' }}>
            {' / '}{castingDirectorName} 담당자
          </span>
        )}
        {isVerified && (
          <span className={styles.verifiedIcon} title="인증된 제작사">
            <Icon name="verified" size="18" color="#FFA40D" />
          </span>
        )}
      </div>
    </div>
  );
}

export default AuditionDetailHero;
